import j from "@arcgis/core/layers/FeatureLayer";
import g from "@arcgis/core/Graphic";
import E from "@arcgis/core/request";
import { createLogger as Q } from "@origo/logger";
import ne from "@arcgis/core/geometry/Point";
import re from "@arcgis/core/geometry/Polygon";
import { z as u } from "zod";
import { jsx as te } from "react/jsx-runtime";
import { createContext as ae, useContext as G } from "react";
import { useQuery as w, useQueryClient as y, useMutation as b } from "@tanstack/react-query";
class F extends Error {
  constructor(n, r) {
    super(n, r), this.name = "PlanregisterError";
  }
}
class k extends F {
  constructor(n, r) {
    super(`${n} not found: ${r}`), this.name = "NotFoundError";
  }
}
class P extends F {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "ValidationError";
  }
}
class h extends F {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "NetworkError";
  }
}
class oe extends F {
  constructor(n = "Unauthorized") {
    super(n), this.name = "AuthError";
  }
}
class V extends F {
  constructor() {
    super("Operation was aborted"), this.name = "AbortedError";
  }
}
const H = "1";
function L(e) {
  return e.trim().padStart(4, "0");
}
function z(e, n) {
  return `${L(e)}_${n.trim()}`;
}
const W = [
  "plantype",
  "planstatus",
  "lovreferanse",
  "forslagsstillerType"
];
function se(e, n, r) {
  return r == null || r === "" ? "" : e?.[n]?.find((l) => l.code === r)?.label ?? r;
}
function le(e, n) {
  return e?.[n] ?? [];
}
const Y = [
  "planbehandlingtype"
], Vn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: V,
  AuthError: oe,
  CODELIST_FIELDS: W,
  DEFAULT_PLANSTATUS: H,
  NetworkError: h,
  NotFoundError: k,
  PLANBEHANDLING_CODELIST_FIELDS: Y,
  PlanregisterError: F,
  ValidationError: P,
  deriveNasjonalArealplanId: z,
  domainLabel: se,
  domainOptions: le,
  normalizeAdmomrkode: L
}, Symbol.toStringTag, { value: "Module" }));
function B(e) {
  if (e != null)
    return new Date(e);
}
function q(e) {
  return !!e;
}
function ie(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer ?? "",
    saksaar: e.saksaar,
    sakssekvensnr: e.sakssekvensnr,
    forslagsstillerType: e.forslagsstillerType,
    ubehandletKlage: q(e.ubehandletKlage),
    ubehandletInnsigelse: q(e.ubehandletInnsigelse),
    vedtaksdato: B(e.vedtaksdato),
    vedtakEndeligPlanDato: B(e.vedtakEndeligPlanDato),
    ikrafttredelsesdato: B(e.ikrafttredelsesdato),
    kunngjoringsdato: B(e.kunngjoringsdato),
    opprinneligAdmomrKode: e.opprinneligAdmomrKode,
    opprinneligPlanId: e.opprinneligPlanId,
    planbestemmelser: q(e.planbestemmelser)
  };
}
function K(e) {
  return {
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer,
    saksaar: e.saksaar ?? null,
    sakssekvensnr: e.sakssekvensnr ?? null,
    forslagsstillerType: e.forslagsstillerType ?? null,
    ubehandletKlage: e.ubehandletKlage ? 1 : 0,
    ubehandletInnsigelse: e.ubehandletInnsigelse ? 1 : 0,
    vedtaksdato: e.vedtaksdato?.getTime() ?? null,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    ikrafttredelsesdato: e.ikrafttredelsesdato?.getTime() ?? null,
    kunngjoringsdato: e.kunngjoringsdato?.getTime() ?? null,
    opprinneligAdmomrKode: e.opprinneligAdmomrKode ?? null,
    opprinneligPlanId: e.opprinneligPlanId ?? null,
    planbestemmelser: e.planbestemmelser ? 1 : 0
  };
}
function Hn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...K(e)
  };
}
function de(e) {
  const n = e;
  return n && n.type === "coded-value" && Array.isArray(n.codedValues) ? n.codedValues : null;
}
function Z(e, n) {
  const r = new Map(e.map((l) => [l.name, l])), a = {};
  for (const l of n) {
    const d = de(r.get(l)?.domain);
    a[l] = d ? d.map((t) => ({ code: String(t.code), label: t.name })) : [];
  }
  return a;
}
function ue(e) {
  return Z(e, W);
}
function ce(e) {
  return e.replace(/'/g, "''");
}
function I(e) {
  return `'${ce(e)}'`;
}
function zn(e, n) {
  return n.length === 0 ? "1=0" : `${e} IN (${n.map(I).join(",")})`;
}
const me = Q("planregister:queryTablePaged"), pe = 2e3, fe = 1e3;
async function C(e, n, r) {
  const a = {
    where: n.where,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    returnGeometry: n.returnGeometry === !0,
    f: "json"
  };
  n.orderByFields && (a.orderByFields = n.orderByFields);
  const l = [];
  let d = 0;
  try {
    for (let t = 0; t < fe; t++) {
      const s = (await E(`${e}/query`, {
        query: { ...a, resultOffset: d, resultRecordCount: pe },
        method: "post",
        responseType: "json",
        signal: r?.signal
      })).data, i = s?.features ?? [];
      for (const p of i)
        l.push(
          p.geometry ? { attributes: p.attributes, geometry: { ...p.geometry, spatialReference: s.spatialReference } } : { attributes: p.attributes }
        );
      if (s?.exceededTransferLimit !== !0 || i.length === 0)
        break;
      d += i.length;
    }
  } catch (t) {
    throw r?.signal?.aborted || ge(t) ? new V() : (me.error(`Feil ved query mot ${e}:`, t), new h(`Query mot ${e} feilet: ${t?.message ?? t}`, t));
  }
  return l;
}
async function D(e, n, r) {
  return (await C(e, n, r)).map((l) => l.attributes);
}
function ge(e) {
  return typeof e != "object" || e === null ? !1 : e.name === "AbortError";
}
function ye(e, n) {
  let r = null;
  const a = () => (r ?? (r = new j({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(ie);
  return {
    findAll: (t) => d("1=1", t),
    findByNapId: async (t, o) => (await d(`nasjonalArealplanId = ${I(t)}`, o))[0] ?? null,
    search: (t, o) => {
      const s = I(`%${t}%`);
      return d(
        `LOWER(plannavn) LIKE LOWER(${s}) OR nasjonalArealplanId LIKE ${s} OR planId LIKE ${s}`,
        o
      );
    },
    add: async (t) => l(async () => {
      const o = new g({ attributes: K(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new k("Arealplan", p);
      return f[0];
    }, "ArealplanRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...K(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new k("Arealplan", t.objectId);
      return i[0];
    }, "ArealplanRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "ArealplanRepository.delete"),
    getDomains: () => l(async () => {
      const t = a();
      return await t.load(), ue(t.fields);
    }, "ArealplanRepository.getDomains")
  };
}
function R(e) {
  if (e != null)
    return new Date(e);
}
function be(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: R(e.dato),
    fradato: R(e.fradato),
    tildato: R(e.tildato),
    saksnummer: e.saksnummer,
    beskrivelse: e.beskrivelse
  };
}
function O(e) {
  return {
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: e.dato?.getTime() ?? null,
    fradato: e.fradato?.getTime() ?? null,
    tildato: e.tildato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
function Wn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...O(e)
  };
}
function he(e) {
  return Z(e, Y);
}
function Ie(e, n) {
  let r = null;
  const a = () => (r ?? (r = new j({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(be);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${I(t)}`, o),
    findByUid: async (t, o) => (await d(`planbehUid = ${I(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({ attributes: O(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new k("Planbehandling", p);
      return f[0];
    }, "PlanbehandlingRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...O(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new k("Planbehandling", t.objectId);
      return i[0];
    }, "PlanbehandlingRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlanbehandlingRepository.delete"),
    getDomains: () => l(async () => {
      const t = a();
      return await t.load(), he(t.fields);
    }, "PlanbehandlingRepository.getDomains")
  };
}
function ke(e) {
  if (e != null)
    return new Date(e);
}
function we(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    planbehUid: e.planbehUid,
    dispensasjonId: e.dispensasjonId,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype,
    dokumentstatus: e.dokumentstatus,
    arkivreferanse: e.arkivreferanse,
    arkivnavn: e.arkivnavn,
    dokumentdato: ke(e.dokumentdato),
    saksnummer: e.saksnummer,
    mimetype: e.mimetype,
    referansedokumentfil: e.referansedokumentfil,
    filnavn: e.filnavn,
    beskrivelse: e.beskrivelse
  };
}
function ve(e) {
  return {
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId ?? null,
    planbehUid: e.planbehUid ?? null,
    dispensasjonId: e.dispensasjonId ?? null,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype ?? null,
    dokumentstatus: e.dokumentstatus ?? null,
    arkivreferanse: e.arkivreferanse ?? null,
    arkivnavn: e.arkivnavn ?? null,
    dokumentdato: e.dokumentdato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    mimetype: e.mimetype ?? null,
    referansedokumentfil: e.referansedokumentfil ?? null,
    filnavn: e.filnavn ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
async function je(e, n, r) {
  const a = new FormData();
  a.append("attachment", r, r.name), a.append("f", "json");
  let l;
  try {
    l = await E(`${e}/${n}/addAttachment`, {
      method: "post",
      body: a,
      responseType: "json"
    });
  } catch (t) {
    throw new h(`Opplasting av vedlegg feilet: ${t?.message ?? t}`, t);
  }
  const d = l.data;
  if (d.error)
    throw new h(`Opplasting av vedlegg feilet: ${d.error.message}`);
  if (!d.addAttachmentResult?.success)
    throw new h("Opplasting av vedlegg feilet");
  return {
    path: `/${n}/attachments/${d.addAttachmentResult.objectId}`,
    filnavn: r.name,
    mimetype: r.type
  };
}
async function Ae(e, n) {
  let r;
  try {
    r = await E(`${e}/${n}/attachments`, {
      query: { f: "json" },
      responseType: "json"
    });
  } catch (l) {
    throw new h(`Henting av vedlegg feilet: ${l?.message ?? l}`, l);
  }
  const a = r.data;
  if (a.error)
    throw new h(`Henting av vedlegg feilet: ${a.error.message}`);
  return (a.attachmentInfos ?? []).map((l) => l.id);
}
async function Fe(e, n) {
  const r = await Ae(e, n);
  if (r.length === 0)
    return;
  let a;
  try {
    a = await E(`${e}/${n}/deleteAttachments`, {
      query: { attachmentIds: r.join(","), f: "json" },
      method: "post",
      responseType: "json"
    });
  } catch (t) {
    throw new h(`Sletting av vedlegg feilet: ${t?.message ?? t}`, t);
  }
  const l = a.data;
  if (l.error)
    throw new h(`Sletting av vedlegg feilet: ${l.error.message}`);
  const d = l.deleteAttachmentResults?.find((t) => !t.success);
  if (d)
    throw new h(`Sletting av vedlegg feilet: ${d.error?.description ?? "ukjent feil"}`);
}
async function Pe(e, n) {
  try {
    const r = n.startsWith("/") ? `${e}${n}` : n, a = await E(r, { responseType: "blob" });
    return URL.createObjectURL(a.data);
  } catch {
    return null;
  }
}
const Ee = Q("planregister:plandokumentRepository");
function De(e, n) {
  let r = null;
  const a = () => (r ?? (r = new j({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(we);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${I(t)}`, o),
    findForBehandling: (t, o) => d(`planbehUid = ${I(t)}`, o),
    findForDispensasjon: (t, o) => d(`dispensasjonId = ${I(t)}`, o),
    add: async (t, o) => l(async () => {
      const s = new g({ attributes: ve(t) }), p = (await a().applyEdits({ addFeatures: [s] })).addFeatureResults[0];
      if (p.error)
        throw new Error(p.error.message);
      const f = p.objectId;
      if (o) {
        const $ = await je(e, f, o), ee = new g({
          attributes: {
            OBJECTID: f,
            referansedokumentfil: $.path,
            filnavn: $.filnavn,
            mimetype: $.mimetype
          }
        });
        await a().applyEdits({ updateFeatures: [ee] });
      }
      const S = await d(`OBJECTID = ${f}`);
      if (!S[0])
        throw new k("Plandokument", f);
      return S[0];
    }, "PlandokumentRepository.add"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
      try {
        await Fe(e, t);
      } catch (s) {
        Ee.warn(`Opprydding av vedlegg for plandokument ${t} feilet etter sletting`, s);
      }
    }, "PlandokumentRepository.delete"),
    fetchAttachmentBlobUrl: (t) => Pe(e, t)
  };
}
function Be(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle,
    organisasjon: e.organisasjon,
    kontaktperson: e.kontaktperson
  };
}
function _(e) {
  return {
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle ?? null,
    organisasjon: e.organisasjon ?? null,
    kontaktperson: e.kontaktperson ?? null
  };
}
function Yn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ..._(e)
  };
}
function Te(e, n) {
  let r = null;
  const a = () => (r ?? (r = new j({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(Be);
  return {
    findForBehandling: (t, o) => d(`planbehUid = ${I(t)}`, o),
    add: async (t) => l(async () => {
      const o = new g({ attributes: _(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new k("Aktor", p);
      return f[0];
    }, "AktorRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ..._(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new k("Aktor", t.objectId);
      return i[0];
    }, "AktorRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "AktorRepository.delete")
  };
}
function $e(e) {
  if (e != null)
    return new Date(e);
}
function qe(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: $e(e.vedtakEndeligPlanDato),
    begrunnelse: e.begrunnelse
  };
}
function Re(e) {
  return {
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    begrunnelse: e.begrunnelse ?? null
  };
}
function Ke(e, n) {
  let r = null;
  const a = () => (r ?? (r = new j({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(qe);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanIdFra = ${I(t)} OR nasjonalArealplanIdTil = ${I(t)}`, o),
    add: async (t) => l(async () => {
      const o = new g({ attributes: Re(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new k("Planforhold", p);
      return f[0];
    }, "PlanforholdRepository.add"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlanforholdRepository.delete")
  };
}
function U(e) {
  if (e != null)
    return new Date(e);
}
function Oe(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: e.kommunenummer,
    planidentifikasjon: e.planidentifikasjon,
    dispensasjonType: e.dispensasjonType,
    dispensasjonFra: e.dispensasjonFra,
    begrunnelse: e.begrunnelse,
    vedtaksdato: new Date(e.vedtaksdato),
    vertikalnivaa: e.vertikalnivaa,
    beskrivelse: e.beskrivelse,
    innvilgetDispensasjon: !!e.innvilgetDispensasjon,
    varigDispensasjon: !!e.varigDispensasjon,
    varighetFra: U(e.varighetFra),
    varighetTil: U(e.varighetTil),
    sakssekvensnummer: e.saksnummer__sakssekvensnummer,
    saksaar: e.saksnummer__saksaar,
    geometry: n
  };
}
function N(e) {
  return {
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: e.kommunenummer ?? null,
    planidentifikasjon: e.planidentifikasjon ?? null,
    dispensasjonType: e.dispensasjonType ?? null,
    dispensasjonFra: e.dispensasjonFra ?? null,
    begrunnelse: e.begrunnelse ?? null,
    vedtaksdato: e.vedtaksdato.getTime(),
    vertikalnivaa: e.vertikalnivaa ?? null,
    beskrivelse: e.beskrivelse ?? null,
    innvilgetDispensasjon: e.innvilgetDispensasjon ? 1 : 0,
    varigDispensasjon: e.varigDispensasjon ? 1 : 0,
    varighetFra: e.varighetFra?.getTime() ?? null,
    varighetTil: e.varighetTil?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null
  };
}
function _e(e, n) {
  let r = null;
  const a = () => (r ?? (r = new j({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await C(e, { where: t, returnGeometry: !0 }, o)).map(
    (i) => Oe(i.attributes, i.geometry ? ne.fromJSON(i.geometry) : void 0)
  );
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${I(t)}`, o),
    findByDispensasjonId: async (t, o) => (await d(`dispensasjonId = ${I(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({
        attributes: N(t),
        geometry: t.geometry
      }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new k("Dispensasjon", p);
      return f[0];
    }, "DispensasjonRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({
        attributes: { OBJECTID: t.objectId, ...N(t) },
        geometry: t.geometry
      }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new k("Dispensasjon", t.objectId);
      return i[0];
    }, "DispensasjonRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "DispensasjonRepository.delete")
  };
}
function J(e) {
  if (e != null)
    return new Date(e);
}
function Le(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn,
    avgjdato: J(e.avgjdato),
    gyldigtildato: J(e.gyldigtildato),
    sakssekvensnummer: e.saksnummer__sakssekvensnummer,
    saksaar: e.saksnummer__saksaar,
    informasjon: e.informasjon,
    geometry: n
  };
}
function M(e) {
  return {
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer ?? null,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn ?? null,
    avgjdato: e.avgjdato?.getTime() ?? null,
    gyldigtildato: e.gyldigtildato?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null,
    informasjon: e.informasjon ?? null
  };
}
function Ce(e, n) {
  let r = null;
  const a = () => (r ?? (r = new j({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await C(e, { where: t, returnGeometry: !0 }, o)).map(
    (i) => Le(i.attributes, i.geometry ? re.fromJSON(i.geometry) : void 0)
  );
  return {
    findForKommune: (t, o) => d(`kommunenummer = ${I(t)}`, o),
    findByForbudId: async (t, o) => (await d(`forbudId = ${I(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({
        attributes: M(t),
        geometry: t.geometry
      }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new k("MidlertidigForbud", p);
      return f[0];
    }, "MidlertidigForbudRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({
        attributes: { OBJECTID: t.objectId, ...M(t) },
        geometry: t.geometry
      }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new k("MidlertidigForbud", t.objectId);
      return i[0];
    }, "MidlertidigForbudRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "MidlertidigForbudRepository.delete")
  };
}
const xe = 0, Se = 1, Ue = 2, Ne = 3, Je = 4, Me = 5, Qe = 6;
function Zn(e) {
  const n = e.serviceUrl.replace(/\/$/, ""), r = (l) => `${n}/${l}`, { getToken: a } = e;
  return {
    arealplaner: ye(r(Ue), a),
    behandlinger: Ie(r(Ne), a),
    dokumenter: De(r(Je), a),
    aktorer: Te(r(Me), a),
    planforhold: Ke(r(Qe), a),
    dispensasjoner: _e(r(xe), a),
    midlertidigeForbud: Ce(r(Se), a)
  };
}
const c = {
  all: ["planregister"],
  arealplaner: {
    all: ["planregister", "arealplaner"],
    search: (e) => ["planregister", "arealplaner", "search", e],
    byNapId: (e) => ["planregister", "arealplaner", e],
    domains: ["planregister", "arealplaner", "domains"]
  },
  behandlinger: {
    all: ["planregister", "behandlinger"],
    forPlan: (e) => ["planregister", "behandlinger", e],
    byUid: (e) => ["planregister", "behandlinger", "uid", e],
    domains: ["planregister", "behandlinger", "domains"]
  },
  dokumenter: {
    all: ["planregister", "dokumenter"],
    forPlan: (e) => ["planregister", "dokumenter", "plan", e],
    forBehandling: (e) => ["planregister", "dokumenter", "behandling", e],
    forDispensasjon: (e) => ["planregister", "dokumenter", "dispensasjon", e]
  },
  aktorer: {
    all: ["planregister", "aktorer"],
    forBehandling: (e) => ["planregister", "aktorer", e]
  },
  planforhold: {
    all: ["planregister", "planforhold"],
    forPlan: (e) => ["planregister", "planforhold", e]
  },
  dispensasjoner: {
    all: ["planregister", "dispensasjoner"],
    forPlan: (e) => ["planregister", "dispensasjoner", e],
    byId: (e) => ["planregister", "dispensasjoner", "id", e]
  },
  midlertidigeForbud: {
    all: ["planregister", "midlertidigeForbud"],
    forKommune: (e) => ["planregister", "midlertidigeForbud", e],
    byId: (e) => ["planregister", "midlertidigeForbud", "id", e]
  }
}, Ge = ["10", "11", "13", "20", "21", "34", "35", "30", "31"], Ve = ["1", "2", "3", "4", "5", "6", "7", "8"], He = ["PBL2008", "PBL1985", "BL1965"], ze = ["1", "2", "3", "4", "9"], T = (e) => ({ errorMap: () => ({ message: e }) }), We = u.object({
  plannavn: u.string().trim().min(1, "Plannavn er påkrevd").max(250, "Plannavn er for langt"),
  plantype: u.enum(Ge, T("Velg en gyldig plantype")),
  planstatus: u.enum(Ve, T("Velg en gyldig planstatus")).optional(),
  lovreferanse: u.enum(He, T("Velg en gyldig lovreferanse")),
  saksnummer: u.string().trim().min(1, "Saksnummer er påkrevd"),
  admomrkode: u.string().trim().min(1, "Kommunenummer er påkrevd").regex(/^\d{1,4}$/, "Kommunenummer må være inntil 4 siffer"),
  planId: u.string().trim().min(1, "PlanID er påkrevd"),
  saksaar: u.number().int().optional(),
  sakssekvensnr: u.number().int().optional(),
  forslagsstillerType: u.enum(ze, T("Velg en gyldig forslagsstillertype")).optional(),
  ubehandletKlage: u.boolean().optional(),
  ubehandletInnsigelse: u.boolean().optional(),
  vedtaksdato: u.date().optional(),
  vedtakEndeligPlanDato: u.date().optional(),
  ikrafttredelsesdato: u.date().optional(),
  kunngjoringsdato: u.date().optional(),
  opprinneligAdmomrKode: u.string().trim().optional(),
  opprinneligPlanId: u.string().trim().optional(),
  planbestemmelser: u.boolean().optional()
}), Ye = u.object({
  planbehUid: u.string().trim().min(1, "planbehUid er påkrevd"),
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  navn: u.string().trim().min(1, "Navn er påkrevd").max(250, "Navn er for langt"),
  planbehandlingtype: u.string().trim().min(1, "Velg behandlingstype"),
  dato: u.date({ required_error: "Dato er påkrevd", invalid_type_error: "Ugyldig dato" }),
  fradato: u.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  tildato: u.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  saksnummer: u.string().trim().max(50, "Saksnummer er for langt").optional(),
  beskrivelse: u.string().trim().max(2e3, "Beskrivelsen er for lang").optional()
}).superRefine((e, n) => {
  e.fradato && e.tildato && e.tildato < e.fradato && n.addIssue({
    code: u.ZodIssueCode.custom,
    path: ["tildato"],
    message: "Til-dato kan ikke være før fra-dato"
  });
}), Ze = u.object({
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  tittel: u.string().trim().min(1, "Tittel er påkrevd").max(250, "Tittel er for lang"),
  dokumenttype: u.string().trim().optional()
});
async function Xe(e, n) {
  return e.arealplaner.findAll(n);
}
async function en(e, n, r) {
  return e.arealplaner.findByNapId(n, r);
}
async function nn(e, n, r) {
  return e.arealplaner.search(n, r);
}
async function rn(e, n, r) {
  const a = We.safeParse(n);
  if (!a.success) {
    const { message: i, path: p } = a.error.issues[0], f = p.join(".");
    throw new P(f ? `${f}: ${i}` : i, a.error);
  }
  const l = a.data, d = L(l.admomrkode), t = z(d, l.planId);
  if (await e.arealplaner.findByNapId(t, r))
    throw new P(
      `Plan-ID «${l.planId.trim()}» finnes allerede i kommune ${d} (${t}).`
    );
  const s = {
    ...l,
    admomrkode: d,
    planId: l.planId.trim(),
    nasjonalArealplanId: t,
    planstatus: l.planstatus ?? H,
    ubehandletKlage: l.ubehandletKlage ?? !1,
    ubehandletInnsigelse: l.ubehandletInnsigelse ?? !1,
    planbestemmelser: l.planbestemmelser ?? !1
  };
  return e.arealplaner.add(s);
}
async function tn(e, n) {
  return e.arealplaner.getDomains(n);
}
async function an(e, n) {
  return e.arealplaner.update(n);
}
async function on(e, n) {
  return e.arealplaner.delete(n);
}
async function sn(e, n) {
  return e.behandlinger.getDomains(n);
}
async function ln(e, n, r) {
  return e.behandlinger.findForPlan(n, r);
}
async function Xn(e, n, r) {
  return e.behandlinger.findByUid(n, r);
}
function X(e) {
  const n = Ye.safeParse(e);
  if (!n.success) {
    const { message: a, path: l } = n.error.issues[0], d = l.join(".");
    throw new P(d ? `${d}: ${a}` : a, n.error);
  }
  const r = n.data;
  return {
    ...r,
    saksnummer: r.saksnummer || void 0,
    beskrivelse: r.beskrivelse || void 0
  };
}
async function dn(e, n) {
  return e.behandlinger.add(X(n));
}
async function un(e, n) {
  const { objectId: r, globalId: a, ...l } = n;
  return e.behandlinger.update({ objectId: r, globalId: a, ...X(l) });
}
async function cn(e, n) {
  return e.behandlinger.delete(n);
}
function mn(e) {
  const n = Ze.safeParse(e);
  if (!n.success) {
    const { message: r, path: a } = n.error.issues[0], l = a.join(".");
    throw new P(l ? `${l}: ${r}` : r, n.error);
  }
  return e;
}
async function pn(e, n, r) {
  return e.dokumenter.findForPlan(n, r);
}
async function fn(e, n, r) {
  return e.dokumenter.findForBehandling(n, r);
}
async function gn(e, n, r) {
  return e.dokumenter.findForDispensasjon(n, r);
}
async function yn(e, n, r) {
  return e.dokumenter.add(mn(n), r);
}
async function bn(e, n) {
  return e.dokumenter.fetchAttachmentBlobUrl(n);
}
async function hn(e, n) {
  return e.dokumenter.delete(n);
}
async function In(e, n, r) {
  return e.aktorer.findForBehandling(n, r);
}
async function kn(e, n) {
  return e.aktorer.add(n);
}
async function wn(e, n) {
  return e.aktorer.update(n);
}
async function vn(e, n) {
  return e.aktorer.delete(n);
}
async function jn(e, n, r) {
  return e.planforhold.findForPlan(n, r);
}
async function An(e, n) {
  return e.planforhold.add(n);
}
async function Fn(e, n) {
  return e.planforhold.delete(n);
}
async function Pn(e, n, r) {
  return e.dispensasjoner.findForPlan(n, r);
}
async function er(e, n, r) {
  return e.dispensasjoner.findByDispensasjonId(n, r);
}
async function En(e, n) {
  return e.dispensasjoner.add(n);
}
async function Dn(e, n) {
  return e.dispensasjoner.update(n);
}
async function Bn(e, n) {
  return e.dispensasjoner.delete(n);
}
async function Tn(e, n, r) {
  return e.midlertidigeForbud.findForKommune(n, r);
}
async function nr(e, n, r) {
  return e.midlertidigeForbud.findByForbudId(n, r);
}
async function $n(e, n) {
  return e.midlertidigeForbud.add(n);
}
async function qn(e, n) {
  return e.midlertidigeForbud.update(n);
}
async function Rn(e, n) {
  return e.midlertidigeForbud.delete(n);
}
const x = ae(null);
function rr({ client: e, children: n }) {
  return /* @__PURE__ */ te(x.Provider, { value: e, children: n });
}
function m() {
  const e = G(x);
  if (!e)
    throw new Error("usePlanregisterClient must be used inside <PlanregisterClientProvider>");
  return e;
}
function tr() {
  return G(x);
}
function ar() {
  const e = m();
  return w({
    queryKey: c.arealplaner.all,
    queryFn: ({ signal: n }) => Xe(e, { signal: n })
  });
}
function or(e) {
  const n = m();
  return w({
    queryKey: c.arealplaner.search(e),
    queryFn: ({ signal: r }) => nn(n, e, { signal: r }),
    enabled: e.length > 0
  });
}
function sr(e) {
  const n = m();
  return w({
    queryKey: c.arealplaner.byNapId(e ?? ""),
    queryFn: ({ signal: r }) => en(n, e, { signal: r }),
    enabled: !!e
  });
}
function lr() {
  const e = m();
  return w({
    queryKey: c.arealplaner.domains,
    queryFn: ({ signal: n }) => tn(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function ir() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => rn(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: c.arealplaner.all })
  });
}
function dr() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => an(e, r),
    onSuccess: (r) => {
      n.invalidateQueries({ queryKey: c.arealplaner.all }), n.invalidateQueries({ queryKey: c.arealplaner.byNapId(r.nasjonalArealplanId) });
    }
  });
}
function ur() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => on(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: c.arealplaner.all })
  });
}
function cr() {
  const e = m();
  return w({
    queryKey: c.behandlinger.domains,
    queryFn: ({ signal: n }) => sn(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function mr(e) {
  const n = m();
  return w({
    queryKey: c.behandlinger.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => ln(n, e, { signal: r }),
    enabled: !!e
  });
}
function pr() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => dn(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: c.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function fr() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => un(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: c.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function gr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => cn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.behandlinger.forPlan(e) })
  });
}
function yr(e) {
  const n = m();
  return w({
    queryKey: c.dokumenter.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => pn(n, e, { signal: r }),
    enabled: !!e
  });
}
function br(e) {
  const n = m();
  return w({
    queryKey: c.dokumenter.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => fn(n, e, { signal: r }),
    enabled: !!e
  });
}
function hr(e) {
  const n = m();
  return w({
    queryKey: c.dokumenter.forDispensasjon(e ?? ""),
    queryFn: ({ signal: r }) => gn(n, e, { signal: r }),
    enabled: !!e
  });
}
function Ir() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => yn(e, r.input, r.file),
    onSuccess: (r) => {
      r.nasjonalArealplanId && n.invalidateQueries({ queryKey: c.dokumenter.forPlan(r.nasjonalArealplanId) }), r.planbehUid && n.invalidateQueries({ queryKey: c.dokumenter.forBehandling(r.planbehUid) });
    }
  });
}
function kr() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => hn(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: c.dokumenter.all })
  });
}
function wr() {
  const e = m();
  return (n) => bn(e, n);
}
function vr(e) {
  const n = m();
  return w({
    queryKey: c.aktorer.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => In(n, e, { signal: r }),
    enabled: !!e
  });
}
function jr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => kn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function Ar(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => wn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function Fr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => vn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function Pr(e) {
  const n = m();
  return w({
    queryKey: c.planforhold.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => jn(n, e, { signal: r }),
    enabled: !!e
  });
}
function Er(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => An(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.planforhold.forPlan(e) })
  });
}
function Dr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => Fn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.planforhold.forPlan(e) })
  });
}
function Br(e) {
  const n = m();
  return w({
    queryKey: c.dispensasjoner.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => Pn(n, e, { signal: r }),
    enabled: !!e
  });
}
function Tr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => En(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function $r(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => Dn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function qr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => Bn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function Rr(e) {
  const n = m();
  return w({
    queryKey: c.midlertidigeForbud.forKommune(e ?? ""),
    queryFn: ({ signal: r }) => Tn(n, e, { signal: r }),
    enabled: !!e
  });
}
function Kr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => $n(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
function Or(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => qn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
function _r(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => Rn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
const Kn = {
  plantype: [
    { code: "10", label: "Fylkesplan" },
    { code: "11", label: "Fylkesdelplan" },
    { code: "13", label: "Regional plan" },
    { code: "20", label: "Kommuneplan" },
    { code: "21", label: "Kommunedelplan" },
    { code: "34", label: "Områderegulering" },
    { code: "35", label: "Detaljregulering" },
    { code: "30", label: "Reguleringsplan (pbl 1985)" },
    { code: "31", label: "Bebyggelsesplan (pbl 1985)" }
  ],
  planstatus: [
    { code: "1", label: "Planlegging igangsatt" },
    { code: "2", label: "Planforslag" },
    { code: "3", label: "Endelig vedtatt" },
    { code: "4", label: "Opphevet" },
    { code: "5", label: "Utgått/erstattet" },
    { code: "6", label: "Vedtatt med utsatt rettsvirkning" },
    { code: "7", label: "Endelig vedtatt med tidsbegrensning" },
    { code: "8", label: "Overstyrt" }
  ],
  lovreferanse: [
    { code: "PBL2008", label: "Plan- og bygningsloven 2008" },
    { code: "PBL1985", label: "Plan- og bygningsloven 1985" },
    { code: "BL1965", label: "Bygningsloven 1965" }
  ],
  forslagsstillerType: [
    { code: "1", label: "Kommunen" },
    { code: "2", label: "Statlig myndighet" },
    { code: "3", label: "Fylkeskommune" },
    { code: "4", label: "Privat forslagsstiller" },
    { code: "9", label: "Annen" }
  ]
}, On = {
  planbehandlingtype: [
    { code: "A", label: "Testbehandling A" },
    { code: "B", label: "Testbehandling B" },
    { code: "C", label: "Testbehandling C" }
  ]
};
let _n = 1;
const v = () => _n++, A = () => `{${v().toString().padStart(8, "0")}-0000-0000-0000-000000000000}`;
class Lr {
  constructor() {
    this.store = [];
  }
  findAll(n) {
    return Promise.resolve([...this.store]);
  }
  findByNapId(n, r) {
    return Promise.resolve(this.store.find((a) => a.nasjonalArealplanId === n) ?? null);
  }
  search(n, r) {
    const a = n.toLowerCase();
    return Promise.resolve(this.store.filter(
      (l) => l.plannavn?.toLowerCase().includes(a) || l.planId.includes(n) || l.nasjonalArealplanId.includes(n)
    ));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Arealplan ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve(Kn);
  }
}
class Cr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findByUid(n, r) {
    return Promise.resolve(this.store.find((a) => a.planbehUid === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Planbehandling ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve(On);
  }
}
class xr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((a) => a.planbehUid === n));
  }
  findForDispensasjon(n, r) {
    return Promise.resolve(this.store.filter((a) => a.dispensasjonId === n));
  }
  add(n, r) {
    const a = {
      ...n,
      objectId: v(),
      globalId: A(),
      ...r ? { filnavn: r.name, mimetype: r.type, referansedokumentfil: `fake://${r.name}` } : {}
    };
    return this.store.push(a), Promise.resolve(a);
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  fetchAttachmentBlobUrl(n) {
    return Promise.resolve(`fake-blob://${n}`);
  }
}
class Sr {
  constructor() {
    this.store = [];
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((a) => a.planbehUid === n));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Aktor ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Ur {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter(
      (a) => a.nasjonalArealplanIdFra === n || a.nasjonalArealplanIdTil === n
    ));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Nr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findByDispensasjonId(n, r) {
    return Promise.resolve(this.store.find((a) => a.dispensasjonId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Dispensasjon ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Jr {
  constructor() {
    this.store = [];
  }
  findForKommune(n, r) {
    return Promise.resolve(this.store.filter((a) => a.kommunenummer === n));
  }
  findByForbudId(n, r) {
    return Promise.resolve(this.store.find((a) => a.forbudId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`MidlertidigForbud ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
export {
  V as AbortedError,
  oe as AuthError,
  W as CODELIST_FIELDS,
  H as DEFAULT_PLANSTATUS,
  Kn as FAKE_AREALPLAN_DOMAINS,
  On as FAKE_PLANBEHANDLING_DOMAINS,
  ze as FORSLAGSSTILLER_VALUES,
  Sr as FakeAktorRepository,
  Lr as FakeArealplanRepository,
  Nr as FakeDispensasjonRepository,
  Jr as FakeMidlertidigForbudRepository,
  Cr as FakePlanbehandlingRepository,
  xr as FakePlandokumentRepository,
  Ur as FakePlanforholdRepository,
  He as LOVREFERANSE_VALUES,
  h as NetworkError,
  k as NotFoundError,
  Y as PLANBEHANDLING_CODELIST_FIELDS,
  Ve as PLANSTATUS_VALUES,
  Ge as PLANTYPE_VALUES,
  rr as PlanregisterClientProvider,
  F as PlanregisterError,
  P as ValidationError,
  Be as aktorFromAttrs,
  _ as aktorInputToAttrs,
  Yn as aktorToAttrs,
  ie as arealplanFromAttrs,
  We as arealplanInputSchema,
  K as arealplanInputToAttrs,
  Hn as arealplanToAttrs,
  ue as buildArealplanDomains,
  Z as buildDomains,
  zn as buildInClause,
  he as buildPlanbehandlingDomains,
  kn as createAktor,
  Te as createArcgisAktorRepository,
  ye as createArcgisArealplanRepository,
  _e as createArcgisDispensasjonRepository,
  Ce as createArcgisMidlertidigForbudRepository,
  Ie as createArcgisPlanbehandlingRepository,
  De as createArcgisPlandokumentRepository,
  Ke as createArcgisPlanforholdRepository,
  rn as createArealplan,
  En as createDispensasjon,
  $n as createMidlertidigForbud,
  dn as createPlanbehandling,
  yn as createPlandokument,
  An as createPlanforhold,
  Zn as createPlanregisterClient,
  vn as deleteAktor,
  on as deleteArealplan,
  Bn as deleteDispensasjon,
  Rn as deleteMidlertidigForbud,
  cn as deletePlanbehandling,
  hn as deletePlandokument,
  Fn as deletePlanforhold,
  z as deriveNasjonalArealplanId,
  Oe as dispensasjonFromAttrs,
  N as dispensasjonInputToAttrs,
  Vn as domain,
  se as domainLabel,
  le as domainOptions,
  ce as escapeSqlValue,
  bn as fetchPlandokumentAttachmentBlobUrl,
  Xe as findAllArealplaner,
  en as findArealplanByNapId,
  Xn as findBehandlingByUid,
  er as findDispensasjonById,
  nr as findMidlertidigForbudById,
  In as loadAktorerForBehandling,
  tn as loadArealplanDomains,
  ln as loadBehandlingerForPlan,
  Pn as loadDispensasjonerForPlan,
  fn as loadDokumenterForBehandling,
  gn as loadDokumenterForDispensasjon,
  pn as loadDokumenterForPlan,
  Tn as loadMidlertidigForbudForKommune,
  sn as loadPlanbehandlingDomains,
  jn as loadPlanforholdForPlan,
  Le as midlertidigForbudFromAttrs,
  M as midlertidigForbudInputToAttrs,
  L as normalizeAdmomrkode,
  be as planbehandlingFromAttrs,
  Ye as planbehandlingInputSchema,
  O as planbehandlingInputToAttrs,
  Wn as planbehandlingToAttrs,
  we as plandokumentFromAttrs,
  Ze as plandokumentInputSchema,
  ve as plandokumentInputToAttrs,
  qe as planforholdFromAttrs,
  Re as planforholdInputToAttrs,
  c as planregisterKeys,
  C as queryFeaturesPaged,
  D as queryTablePaged,
  I as qv,
  nn as searchArealplaner,
  wn as updateAktor,
  an as updateArealplan,
  Dn as updateDispensasjon,
  qn as updateMidlertidigForbud,
  un as updatePlanbehandling,
  vr as useAktorer,
  sr as useArealplan,
  lr as useArealplanDomains,
  ar as useArealplaner,
  or as useArealplanerSearch,
  jr as useCreateAktor,
  ir as useCreateArealplan,
  Tr as useCreateDispensasjon,
  Kr as useCreateMidlertidigForbud,
  pr as useCreatePlanbehandling,
  Ir as useCreatePlandokument,
  Er as useCreatePlanforhold,
  Fr as useDeleteAktor,
  ur as useDeleteArealplan,
  qr as useDeleteDispensasjon,
  _r as useDeleteMidlertidigForbud,
  gr as useDeletePlanbehandling,
  kr as useDeletePlandokument,
  Dr as useDeletePlanforhold,
  Br as useDispensasjoner,
  wr as useFetchPlandokumentAttachmentUrl,
  Rr as useMidlertidigeForbud,
  cr as usePlanbehandlingDomains,
  mr as usePlanbehandlinger,
  br as usePlandokumenterForBehandling,
  hr as usePlandokumenterForDispensasjon,
  yr as usePlandokumenterForPlan,
  Pr as usePlanforhold,
  m as usePlanregisterClient,
  tr as usePlanregisterClientOptional,
  Ar as useUpdateAktor,
  dr as useUpdateArealplan,
  $r as useUpdateDispensasjon,
  Or as useUpdateMidlertidigForbud,
  fr as useUpdatePlanbehandling
};
//# sourceMappingURL=index.mjs.map
